<template>
  <v-progress-linear :value="progressValue" v-bind="$props" v-on="$listeners" />
</template>

<script>
import { VProgressCircular } from 'vuetify/lib';
import networkProgress from '../mixins/network-progress';

export default {
  name: 'ProgressLinearTimeout',
  extends: VProgressCircular,
  mixins: [networkProgress],
};
</script>
